import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { Section, Title } from '../styled/StyledComponents';
import { contentVariants } from '../animations/Variants';

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  padding: 2rem;
  margin: 0 auto;
  max-width: 1200px;
`;

const ImageContainer = styled(motion.div)`
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  aspect-ratio: 4/3;
  cursor: pointer;

  &:hover {
    img {
      transform: scale(1.05);
    }
    
    .overlay {
      opacity: 1;
    }
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  padding: 1rem;
`;

const ImageTitle = styled.h3`
  color: white;
  text-align: center;
  font-size: 1.2rem;
  margin: 0;
`;

const GalerieSection: React.FC = () => {
  const images = [
    {
      src: '/assets/images/galerie1.jpg',
      title: 'Salle de Psychomotricité'
    },
    {
      src: '/assets/images/galerie2.jpg',
      title: 'Espace de Jeu'
    },
    {
      src: '/assets/images/galerie3.jpg',
      title: 'Matériel Thérapeutique'
    },
    {
      src: '/assets/images/galerie4.jpg',
      title: 'Espace Sensoriel'
    },
    {
      src: '/assets/images/galerie5.jpg',
      title: 'Zone de Motricité'
    },
    {
      src: '/assets/images/galerie6.jpg',
      title: 'Espace de Relaxation'
    }
  ];

  return (
    <motion.div
      key="galerie"
      initial="enter"
      animate="center"
      exit="exit"
      variants={contentVariants}
    >
      <Section>
        <Title>Galerie</Title>
        <GalleryGrid>
          {images.map((image, index) => (
            <ImageContainer
              key={index}
              whileHover={{ y: -5 }}
              transition={{ duration: 0.2 }}
            >
              <Image src={image.src} alt={image.title} />
              <Overlay className="overlay">
                <ImageTitle>{image.title}</ImageTitle>
              </Overlay>
            </ImageContainer>
          ))}
        </GalleryGrid>
      </Section>
    </motion.div>
  );
};

export default GalerieSection;
